const PATH = {
  home: '/',
  login: '/login',
  information: '/printing-information',
  gallery: '/gallery',
  packaging: '/packaging-catalog',
  request: '/quotation-request',
  payment: '/payment-verification',
  socialLogin: '/socialLogin',
  member: '/profile',
  paper: '/printing-information/paper',
  printingTechnique: '/printing-information/printing-technique',
  register: '/register',
  activate: '/activate/:token',
  forgetPassword: '/forget-password',
  resetPassword: '/reset-password/:token',
  packagingDetail: '/packaging-catalog',
}

export default PATH



// WEBPACK FOOTER //
// ./src/constants/path.js